/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Puscas
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface PriceType {
  id: number;
  header: string;
  syncUid?: string;
  enabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
